<app-sidebar></app-sidebar>

<div class="layout-sidebar-push layout-body">
    <div class="tabs-container">
        <ul class="float-right tabs">
            <li class="tab tab-button">
                <button type="button" class="button button-basic" (click)="onBack()">{{ 'shared.button.back' | translate }}</button>
            </li>
        </ul>
        <h2 class="head-main" *ngIf="offer.type">
            {{ 'offers.preview.heading' | translate }} / {{ 'offers.shared.types.' + offer.type | translate }} / {{ recipientHeadingName() | translate }}
        </h2>
    </div>

    <app-loading *ngIf="loading"></app-loading>

    <form #form="ngForm" [class.ng-submitted]="submitted">
        <div *ngIf="!loading">
            <div class="row">
                <div class="small-8">
                    <div class="card">
                        <div class="card-header">
                            <h2 style="flex:1" >{{ 'offers.preview.heading.essential' | translate }}</h2>
                            <app-status-square style="flex:0" [status]="offer.status"></app-status-square>
                        </div>

                        <div class="card-body">
                            <ng-container
                                *ngTemplateOutlet=" offerIsNotEditable? pictureReadOnly
                                :(offer.type==='CASHBACK')?strategyPictureList
                                :pictureUploader">
                            </ng-container>
                            <h1>{{ offer.name }}</h1>
                            <p>
                                <strong>{{ offer.reference }}</strong>
                                <span *ngIf="offer.brand">— Published by <strong>{{ offer.brand.name }}</strong></span>
                            </p>
                            <p [innerHTML]="offer.description | newlines"></p>

                            <table>
                                <colgroup>
                                    <col style="width:260px">
                                    <col>
                                </colgroup>

                                <!-- All types top -->

                                <tr class="scope-table-header">
                                    <th colspan="4">
                                        {{ 'shared.label.offer-lifespan' | translate }}
                                    </th>
                                </tr>

                                <tr>
                                    <th>{{ 'shared.label.dates' | translate }}</th>
                                    <td>
                                        {{ offer.start_date | localizedDate : 'shortDate' : 'UTC' }}
                                        <span class="table-symbol">→</span>
                                        <span *ngIf="offer.end_date">
                                            {{ offer.end_date | localizedDate: 'shortDate' : 'UTC' }}
                                        </span>
                                        <span *ngIf="!offer.end_date">
                                            ∞
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ 'shared.label.publication-date' | translate }}</th>
                                    <td>
                                        {{ offer.publication_date | localizedDate : 'shortDate' : 'UTC' }}
                                        {{ offer.publication_date | date : 'HH:mm' : 'UTC' }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ 'offers.shared.label.end-date' | translate }}</th>
                                    <td>
                                        <span *ngIf="offer.end_date">
                                            {{ offer.end_date | localizedDate: 'shortDate' : 'UTC' }}
                                        </span>
                                        <span *ngIf="!offer.end_date">
                                            ∞
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ 'offers.shared.label.deactivated-at' | translate }}</th>
                                    <td>
                                        {{ offer.deactivated_at | localizedDate : 'shortDate' : 'UTC' }}
                                        <span *ngIf="offer.deactivated_at">
                                            {{ offer.deactivated_at | localizedDate: 'shortDate' : 'UTC' }}
                                        </span>
                                        <span *ngIf="!offer.deactivated_at">
                                            {{ 'shared.no' | translate }}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ 'offers.shared.label.completed-at' | translate }}</th>
                                    <td>
                                        {{ offer.completed_at | localizedDate : 'shortDate' : 'UTC' }}
                                        <span *ngIf="offer.completed_at">
                                            {{ offer.completed_at | localizedDate: 'shortDate' : 'UTC' }}
                                        </span>
                                        <span *ngIf="!offer.completed_at">
                                            {{ 'shared.no' | translate }}
                                        </span>
                                    </td>
                                </tr>

                                <!-- Cashbacks -->

                                <tr class="scope-table-header">
                                    <th colspan="4">
                                        {{ 'shared.label.reward-info' | translate }}
                                    </th>
                                </tr>

                                <tbody *ngIf="offer.type === 'CASHBACK' || offer.type === 'LBS_CASHBACK'">
                                    <tr>
                                        <th>{{ 'shared.label.type' | translate }}</th>
                                        <td>{{ 'offers.shared.types.' + offer.type | translate }}</td>
                                    </tr>
                                    <tr *ngIf="!isNotEditable()">
                                        <th>{{ 'shared.label.reward-current' | translate }}</th>
                                        <td>
                                            {{ offer.cashback_rate }}%
                                            <span *ngIf="transactionSource && offer.is_main_source_transaction" >
                                                — {{ 'offers.list.is-main-source-transaction' | translate : { source: transactionSource } }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ 'shared.label.rewarded-price-range' | translate }}</th>
                                        <td>
                                            {{ (offer.min_amount || 0) | localizedNumber : '1.2-2' }}€
                                            <span class="table-symbol">→</span>
                                            {{ offer.max_amount ? ((offer.max_amount| localizedNumber : '1.2-2') + '€') : '∞' }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ 'shared.label.max-limit-transaction-amount' | translate }}</th>
                                        <td>
                                            {{ offer.max_limit_transaction_amount ? ((offer.max_limit_transaction_amount| localizedNumber : '1.2-2') + '€') : '∞' }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ 'shared.label.validation-delay' | translate }}</th>
                                        <td>
                                            {{ offer.brand?.cashback_validation_delay_days | localizedNumber }} {{ 'shared.date.days' | translate }}
                                        </td>
                                    </tr>
                                </tbody>

                                <tr *ngIf="offer.loyalty_transaction_frequency">
                                    <th>{{ 'shared.label.reward-frequency' | translate }}</th>
                                    <td>
                                        {{ 'shared.counts.frequency' | translate:  { frequency: offer.loyalty_transaction_frequency } }}
                                    </td>
                                </tr>

                                <!-- Generic coupons -->

                                <tbody *ngIf="offer.type === 'GENERIC_COUPON'">
                                    <tr>
                                        <th>{{ 'shared.label.type' | translate }}</th>
                                        <td>{{ 'offers.shared.types.' + offer.type | translate }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ 'shared.label.coupon' | translate }}</th>
                                        <td>{{ offer.coupon_generic_code }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ 'shared.label.coupon-type' | translate }}</th>
                                        <td>{{ offer.coupon_diffusion_type || '-' }}</td>
                                    </tr>
                                </tbody>

                                <!-- Unique coupons -->

                                <tbody *ngIf="offer.type === 'UNIQUE_COUPON'">
                                    <tr>
                                        <th>{{ 'shared.label.type' | translate }}</th>
                                        <td>{{ 'offers.shared.types.' + offer.type | translate }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ 'shared.label.coupon-type' | translate }}</th>
                                        <td>{{ offer.coupon_diffusion_type || '-' }}</td>
                                    </tr>
                                </tbody>

                                <!-- All types bottom -->

                                <tr>
                                    <th>{{ 'shared.label.application' | translate }}</th>
                                    <td>
                                        <span *ngIf="offer.application_channel === 'OFFLINE'">
                                            {{ 'offers.preview.status.' + offer.application_channel | translate  }}
                                        </span>
                                        <a *ngIf="offer.application_channel !== 'OFFLINE'" [href]="offer.application_url" target="_blank" rel="noopener noreferrer">
                                            {{ 'offers.preview.status.' + offer.application_channel | translate  }}
                                        </a>
                                    </td>
                                </tr>

                                <tr *ngIf="offer.commission_percent">
                                    <th>{{ 'shared.label.commission' | translate }}</th>
                                    <td>
                                        {{ offer.commission_percent }}%
                                    </td>
                                </tr>

                                <tr class="scope-table-header" *ngIf="offer.type === 'CASHBACK' || offer.type === 'LBS_CASHBACK'">
                                    <th colspan="4">
                                        {{ 'shared.label.audience-reach' | translate }}
                                    </th>
                                </tr>

                                <tbody *ngIf="offer.type !== 'VOUCHER'">
                                    <tr>
                                        <th>{{ 'shared.label.targeting' | translate }}</th>
                                        <td>
                                            {{ (offer.is_targeted ? 'shared.yes' : 'shared.no') | translate }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>{{ 'shared.label.ab-testing' | translate }}</th>
                                        <td>
                                            {{ (offer.is_ab_tested ? 'shared.yes' : 'shared.no') | translate }}
                                        </td>
                                    </tr>

                                    <tr *ngIf="offer.isCoupon">
                                        <th>{{ 'shared.label.capping' | translate }}<span *ngIf="offer.capping_period"> ({{ 'shared.granularity.' + offer.capping_period?.toLowerCase() | translate }})</span></th>
                                        <td>
                                            {{ (offer.max_coupon_per_user || 0) | localizedNumber }}
                                        </td>
                                    </tr>

                                    <tr *ngIf="!offer.isCoupon && offer.max_cashbacks_per_consumer !== null">
                                        <th>{{ 'shared.label.capping' | translate }}<span *ngIf="offer.capping_period"> ({{ 'shared.granularity.' + offer.capping_period?.toLowerCase() | translate }})</span></th>
                                        <td>
                                            {{ (offer.max_cashbacks_per_consumer || 0) | localizedNumber }}
                                        </td>
                                    </tr>
                                </tbody>

                                <tr *ngIf="hasSegments">
                                    <th>{{ 'shared.label.segments' | translate }}</th>
                                    <td>
                                        <app-expandable-list [list]="offer.segments" key="name" placeholder="shared.no"
                                            limit="10"></app-expandable-list>
                                    </td>
                                </tr>

                                <tr *ngIf="offer.audience">
                                    <th>{{ 'shared.label.audience-estimated' | translate }}</th>
                                    <td [ngSwitch]="getAudienceState()">
                                        <ng-container *ngSwitchCase="'future'">
                                            {{ 'shared.label.audience-will-be-computed' | translate }}
                                        </ng-container>

                                        <ng-container *ngSwitchCase="'computing'">
                                            {{ 'shared.label.audience-computing-in-progress' | translate }}
                                        </ng-container>

                                        <ng-container *ngSwitchDefault>
                                            {{ (offer.audience.actual || 0) | localizedNumber }}

                                            <a class="action-link" style="margin-left: 5px" (click)="onDownload(offer.audience.download_url, offer)">
                                                [ {{ 'shared.button.download' | translate }} ]
                                            </a>
                                        </ng-container>
                                    </td>
                                </tr>

                                <tr *ngIf="offer.type === 'AFFILIATION' && offer.max_reward_rate !== null">
                                    <th>{{ 'shared.label.reward-rate-max' | translate }}</th>
                                    <td>
                                        {{ offer.max_reward_rate | localizedNumber: '1.0-2' }}%
                                    </td>
                                </tr>

                                <tr *ngIf="offer.type === 'AFFILIATION' && offer.max_fixed_reward_amount !== null">
                                    <th>{{ 'shared.label.reward-amount-fixed' | translate }}</th>
                                    <td>
                                        {{ offer.max_fixed_reward_amount | localizedNumber: '1.0-2' }}€
                                    </td>
                                </tr>
                            </table>

                            <div *ngIf="offer.deep_link_url" class="scope-deeplink">
                                <label>Deep link</label>
                                <input readonly type="text" [value]="offer.deep_link_url">
                            </div>

                            <div *ngIf="![ 'CASHBACK', 'LBS_CASHBACK' ].includes(offer.type)">
                                <div class="action-link">
                                    <a (click)="isOfferTermsOpen = !isOfferTermsOpen">{{ (isOfferTermsOpen ? 'shared.button.terms-hide' : 'shared.button.terms-show') | translate }}</a>
                                    <span>{{ (isOfferTermsOpen ? '▲' : '▼')}}</span>
                                </div>

                                <div [hidden]="!isOfferTermsOpen" class="terms" [innerHTML]="(offer.legal_terms || '...') | newlines"></div>
                            </div>
                        </div>
                    </div>

                    <app-card-offer-cpa
                        *ngIf="offer && offer.type !== 'VOUCHER'"
                        [offer]="offer"
                        [strategy]="strategy">
                    </app-card-offer-cpa>

                    <app-card-affiliation-commissions
                        *ngIf="!loading && offer.strategy"
                        [groups]="offer.commission_groups"
                        [commissions]="offer.strategy?.commissions">
                    </app-card-affiliation-commissions>

                    <app-card-brand-details
                        *ngIf="!loading && offer.brand"
                        [brand]="offer.brand">
                    </app-card-brand-details>

                    <app-card-program-details
                        *ngIf="!loading && program"
                        [program]="program">
                    </app-card-program-details>

                    <div *ngIf="offer.brand">
                        <app-offer-form-recipients
                            [model]="offer"
                            [hidden]="loading">
                        </app-offer-form-recipients>
                    </div>
                </div>

                <div class="small-4">
                    <div class="card">
                        <div class="card-header">
                            <h2>{{ 'offers.preview.heading.quickedit' | translate }}</h2>
                        </div>
                        <div class="card-body">
                            <div class="form-row" *ngIf="offer.is_activated && offer.end_date">
                                <label>{{ 'shared.label.remaining-time' | translate }}</label>
                                <app-countdown [date]="offer.end_date"></app-countdown>
                            </div>

                            <app-form-multi-input
                                label="shared.label.offer-name"
                                name="name"
                                [required]="!isNotEditable()"
                                [disabled]="isNotEditable()"
                                [(ngModel)]="offer.name"
                                [translation]="offer.translation?.name">
                            </app-form-multi-input>

                            <app-form-multi-input
                                type="tag"
                                rows="5"
                                label="shared.label.description"
                                name="description"
                                [tags]="['rate']"
                                [required]="!isNotEditable()"
                                [disabled]="isNotEditable()"
                                [(ngModel)]="offer.description"
                                [translation]="offer.translation?.description">
                            </app-form-multi-input>

                            <app-form-multi-input
                                type="tag"
                                rows="5"
                                label="shared.label.terms"
                                name="legal_terms"
                                placeholder="shared.label.terms"
                                [required]="!isNotEditable()"
                                [disabled]="isNotEditable()"
                                [(ngModel)]="offer.legal_terms"
                                [translation]="offer.translation?.legal_terms">
                            </app-form-multi-input>
<!--
                            <div class="form-row">
                                <label>{{ 'shared.label.application' | translate }}</label>
                                <select
                                    name="application_channel"
                                    [disabled]="true"
                                    [(ngModel)]="offer.application_channel">
                                    <option value="ONLINE">{{ 'shared.label.online' | translate }}</option>
                                    <option value="OFFLINE">{{ 'shared.label.offline' | translate }}</option>
                                    <option value="BOTH">{{ 'shared.label.online-offline' | translate }}</option>
                                </select>
                            </div> -->

                            <app-form-multi-input
                                name="application_url"
                                label="shared.label.channel-url"
                                placeholder="offers.preview.application.placeholder.url"
                                [required]="offer.application_channel === 'ONLINE' && !disabled"
                                [disabled]="isNotEditable() || offer.application_channel === 'OFFLINE' || disabled"
                                [(ngModel)]="offer.application_url"
                                [translation]="offer.translation?.application_url">
                            </app-form-multi-input>

                            <div class="form-row">
                                <label>{{ 'shared.label.highlight-level' | translate }}</label>
                                <ul class="form-checkbox-list">
                                    <li class="form-checkbox-item"
                                        *ngFor="let choice of highlight_levels; let index = index;"
                                        [class.active]="offer.highlight_level === choice">
                                        <label>
                                            <input
                                                type="radio"
                                                [name]="'highlight' + index"
                                                [value]="choice"
                                                [disabled]="isNotEditable()"
                                                [(ngModel)]="offer.highlight_level">
                                            {{ 'shared.status.' + choice | translate }}
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="card-body" *ngIf="!isNotEditable()">
                            <div class="flex">
                                <div>
                                    <div *ngIf="isActiveToggleDisplayed()">
                                        <app-form-toggle
                                            name="is_activated"
                                            [disabled]="isActivationDisabled()"
                                            [(ngModel)]="isActivationToggled"
                                            (ngModelChange)="onActivationChange(isActivationToggled)">
                                        </app-form-toggle>
                                        <span *ngIf="isActivationToggled">{{ 'offers.shared.label.offer-active' | translate }}</span>
                                        <span *ngIf="!isActivationToggled">{{ 'offers.shared.label.offer-inactive' | translate }}</span>
                                    </div>
                                </div>
                                <button type="button" class="button button-primary" [disabled]="form.invalid"
                                        (click)="onSave(form)">
                                    {{ 'shared.button.save' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<ng-template #strategyPictureList>
        <app-multi-images-selectable-list
            [enableSelect]="true"
            [rowHeight]="'16:9'"
            [compact]="true"
            [(selected)]="offer.picture"
        >
        <ng-container *ngFor="let picture of (strategy | allstrategypictures)">
            <app-decorated-uploader
                *appPickerChoice="picture.picture"
                [aspectRatio]="'16-9'"
                [enableRemove]="false"
                [disableUpload]="true"
                [uploadedFile]="{ usage:picture.illustration_usage_name, media:picture.picture }"
                [illustrationUsage]="{ name:'fake', forceRatio:true}"
            >
            </app-decorated-uploader>
        </ng-container>

        <ng-container *ngIf="customPicture">
            <app-decorated-uploader
                *appPickerChoice="customPicture"
                [aspectRatio]="'16-9'"
                [enableRemove]="false"
                [disableUpload]="false"
                [uploadedFile]="{usage:null, media: customPicture}"
                [illustrationUsage]="{ name:'fake', forceRatio:true}"
                (uploaded)="onCustomFileUploaded($event)"
            ></app-decorated-uploader>
        </ng-container>
    </app-multi-images-selectable-list>

    <div class="actions">
        <button type="button"
                class="button button-basic"
                (click)="customUploader.click(); $event.stopPropagation();"
        >
            <span>{{ 'offers.shared.label.custom' | translate }}</span>
            <span class="i"
                [class.i-plus]="!customPicture"
                [class.i-edit]="!!customPicture"
                [ngStyle]="{height:'1.33em', 'margin':'0 1rem 0 1rem'}">
            </span>
        </button>

        <app-uploader
            [style.max-height]="'100%'"
            #customUploader
            [type]="'button'"
            [types]="[ 'image/png', 'image/jpg', 'image/jpeg' ]"
            [maxSize]="4 * 1024 * 1024"
            (fileSelected)="onFileSelected($event)"
            (fileUploaded)="onCustomFileUploaded($event)">
        </app-uploader>
        <app-form-errors [errors]="selectedFile.errors"></app-form-errors>
    </div>
</ng-template>

<ng-template #pictureUploader>
    <input type="hidden" name="picture" [ngModel]="offer.picture">
    <div class="uploader-container ratio-16-9">
        <div class="uploader">

            <a (click)="onFileRemoved()" class="uploader-button-remove" *ngIf="offer.picture">
                <i class="i i-cross-circle"></i>
            </a>

            <app-uploader
                icon="i-image"
                [preview]="offer.picture | imageFromApi"
                [types]="[ 'image/png', 'image/jpg', 'image/jpeg' ]"
                [maxSize]="5 * 1024 * 1024"
                [minWidth]="750"
                [minHeight]="421"
                (fileSelected)="onFileSelected($event)"
                (fileUploaded)="onFileUploaded($event)">
            </app-uploader>
        </div>
    </div>
    <app-form-errors [errors]="selectedFile.errors"></app-form-errors>
</ng-template>

<ng-template #pictureReadOnly>
    <div class="ratio-16-9">
        <div *ngIf="offer.picture"
                [style.background-image]="'url(' + (offer.picture | imageFromApi) + ')'"
                [style.background-size]="'cover'"
        ></div>
    </div>
</ng-template>
